<template>
  <div class="intro_wrap">
    <div class="intro">
      <page-header class="not_main"></page-header>
      <div class="intro_content">
        <image-component :infoType="'fatherBanner'" class=""></image-component>
        <div class="intro_tab_wrap">
          <div class="tab">
            <div class="tab_content" :class="{'active': tab=='vision'}" @click="changeTab('vision')">비전</div>
            <div class="tab_content" :class="{'active': tab=='business'}" @click="changeTab('business')">주요사업</div>
            <div class="tab_content" :class="{'active': tab=='info'}" @click="changeTab('info')">발자취</div>
            <div class="tab_content" :class="{'active': tab=='financial'}" @click="changeTab('financial')">재무보고</div>
          </div>
        </div>

        <image-component v-if="tab === 'vision'" :infoType="'vision'"></image-component>

        <board-list-component v-else-if="tab ==='business'" :boardType="'business'"></board-list-component>

        <history-component v-else-if="tab ==='info'"></history-component>

        <board-list-component v-else-if="tab ==='financial'" :boardType="'financial'"></board-list-component>

        <div v-else-if="tab ==='donation'">
          <file-component></file-component>
          <image-component :infoType="'donation'"></image-component>
        </div>
      </div>
      <page-footer class="not_main"></page-footer>
    </div>
  </div>
</template>

<script>
import ImageComponent from "@/components/information/ImageComponent";
import BoardListComponent from "@/components/board/BoardListComponent";
import HistoryComponent from "@/components/history/HistoryComponent";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import FileComponent from "@/components/file/FileComponent";

export default {
  name: "Intro",
  mixins: [],
  components: {FileComponent, HistoryComponent, BoardListComponent, ImageComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      tab: 'vision',
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.tab = this.$route.query.tab;
    if (util.isEmpty(this.tab)) {
      this.changeTab('vision');
    }

  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    changeTab(val) {
      this.tab = ''
      this.$nextTick(() => {
        this.tab = val;
      })
      this.$router.replace(`${this.$route.path}?tab=${val}`);
    },

  },
  watch: {
    "$route.fullPath": {
      deep: true,
      handler: function (val, oldVal) {
        if(this.tab != this.$route.query.tab) {
          this.changeTab(this.$route.query.tab);
        }
      }
    }

  },
}
</script>

<style scoped>

</style>
